export enum ApplicationActionTypes {
    Launch = 'Launch',
    ComingSoon = 'Coming soon',
    LearnMore = 'Learn more'
}
